









































































import { Vue, Component, Prop, Watch, PropSync } from 'vue-property-decorator'
import { Atributo } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { DataOptions } from 'vuetify'
import { Page } from '@/models'
import { Pageable } from '@/models/Pageable'
import axios, { CancelTokenSource } from 'axios'
import { ObserveVisibility } from 'vue-observe-visibility'
import { FindAtributoUseCase } from '@/usecases/produto/FindAtributoUseCase'

@Component({
	directives: {
		ObserveVisibility,
	},
})
export default class SeletorDeAtributo extends Vue {
	@PropSync('value', { type: [Object, Array], default: null }) atributo!: (string | Atributo) | (string | Atributo)[] | null
	@Prop({ type: Boolean }) podeCriar!: boolean
	@Prop({ type: Boolean }) podeEditar!: boolean
	@Prop({ type: Boolean }) returnObject!: boolean
	@Prop({ type: Boolean }) multiple!: boolean
	@Prop({ type: Array, default: () => [] }) ignores?: (Atributo | null)[]
	busca = ''
	itemEditando: null | ItemSelecao = null
	itensBuscados: ItemSelecao[] = []
	findAtributoUseCase = new FindAtributoUseCase()

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	pagina: Page<Atributo> | null = null
	cancelToken: CancelTokenSource | null = null
	buscandoMaisItens = false
	buscandoNovosItens = true
	readonly ATRIBUTOS_PERMITIDOS = ['Cor', 'Tamanho']

	created() {
		this.podeCriar = false
		this.buscarNovosItens()
	}

	atributoEmItemAutocompletar(atributo: Atributo | string): ItemSelecao {
		return typeof atributo === 'string'
			? {
				id: '',
				nome: atributo,
				tipo: 'selecao',
			}
			: {
				...atributo,
				tipo: 'selecao',
			}
	}

	get itens() {
		let itens: ItemAutocompletar[] = [];
		if (this.atributo !== null) {
			if (Array.isArray(this.atributo)) {
				itens = this.atributo.map(this.atributoEmItemAutocompletar)
			} else {
				itens = [this.atributoEmItemAutocompletar(this.atributo)]
			}
		}

		const idsJaSelecionados = new Set(itens.map(i => (i as any).id));

		const itensFiltradosSemDuplicatas = this.itensFiltrados.filter(
			item => !idsJaSelecionados.has(item.id),
		);

		itens = [
			...itens,
			...itensFiltradosSemDuplicatas,
		]

		if (this.pagina && !this.pagina.last && !this.buscandoNovosItens) {
			itens.push({ tipo: 'buscar-mais' })
		}

		return itens
	}

	get itensFiltrados() {
		const ignores = this.ignores
		let base = this.itensBuscados
		if (ignores) {
			base = base.filter(
				(atributo) => ignores.every(
					(atributoAExcluir) => atributoAExcluir?.id !== atributo.id,
				),
			)
		}
		return base
	}

	obterNomeAtributo(atributo: Atributo | string) {
		return typeof atributo === 'string'
			? atributo
			: atributo.nome
	}

	async selecionaItem(item: ItemSelecao | ItemNovo) {
		if (!item) {
			this.$emit('input', null)
			return
		}

		if (item && (item as any).tipo === 'novo') {
			AlertModule.setError('Criação de novos atributos não é permitida aqui.')
			return
		}

		this.$emit('input', item)
	}

	async criarAtributo() {
		AlertModule.setError('Criação de novos atributos não é permitida. Apenas "Cor" e "Tamanho" carregados do sistema são válidos.')
		return null
	}

	emitirInput(item: ItemSelecao) {
		if (!Array.isArray(this.atributo)) {
			this.$emit('input', this.returnObject
				? item
				: item.id,
			)
		} else {
			const atributos = this.atributo || []
			this.$emit('input', [
				...atributos,
				item,
			])
		}
	}

	editar(item) {
		this.itemEditando = { ...item }
	}

	async confirmarEdicao() {
		if (!this.itemEditando) {
			return
		}
		if (!this.itemEditando.nome) {
			this.itemEditando = null
			return
		}
		const indice = this.itensBuscados.findIndex(
			item => item.id === this.itemEditando?.id,
		)
		if (indice === -1) return

		this.itensBuscados.splice(indice, 1, this.itemEditando)
		this.itemEditando = null
	}

	async buscar(paginavel: Pageable = {}): Promise<Atributo[]> {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			this.pagina = await this.findAtributoUseCase.find({
				busca: this.busca || undefined,
				page: paginavel.page || 0,
				size: paginavel.size || 10,
				sort: 'nome',
			}, axiosConfig);
			this.paginacao.page = this.pagina.number
			return this.pagina.content
		} catch (e) {
			if (axios.isCancel(e)) throw e
			AlertModule.setError(e)
			throw e
		}
	}

	async buscarNovosItens() {
		this.buscandoNovosItens = true
		const atributos = await this.buscar({
			...this.paginacao,
			page: 0,
		})
		this.itensBuscados = []
		const filtrados = atributos.filter(a => this.ATRIBUTOS_PERMITIDOS.includes(a.nome))
		this.inserirAtributos(filtrados)
		this.buscandoNovosItens = false
	}

	async buscarMaisItens() {
		this.buscandoMaisItens = true
		const atributos = await this.buscar({
			...this.paginacao,
			page: this.paginacao.page + 1,
		})
		const filtrados = atributos.filter(a => this.ATRIBUTOS_PERMITIDOS.includes(a.nome))
		this.inserirAtributos(filtrados)
		this.buscandoMaisItens = false
	}

	inserirAtributos(atributos: Atributo[]) {
		const existentesIds = new Set(this.itensBuscados.map(i => i.id))
		const novos = atributos
			.filter(a => !existentesIds.has(a.id))
			.map<ItemSelecao>(item => ({
				...item,
				tipo: 'selecao',
			}))
		this.itensBuscados = [
			...this.itensBuscados,
			...novos,
		]
	}

	@Watch('busca')
	onChangeBusca(buscaAtual, buscaAnterior) {
		if (buscaAtual === buscaAnterior) return
		this.buscarNovosItens()
	}

	mudouVisibilidade(visivel) {
		if (visivel && !this.buscandoMaisItens) this.buscarMaisItens()
	}
}

export type ItemHeader = {
	tipo: 'header'
	header: string
}

export type ItemSelecao = Atributo & {
	tipo: 'selecao'
}

export type ItemNovo = {
	tipo: 'novo'
	text: string
}

export type ItemBuscarMais = {
	tipo: 'buscar-mais'
}

export type ItemAutocompletar = ItemHeader | ItemSelecao | ItemNovo | ItemBuscarMais
